<template>
    <nav class="py-8 md:py-16 lg:flex items-center">
        <h6 class="pb-6 lg:pr-6 lg:relative lg:top-1 h5 text-blue-navy">
            Filter by:
        </h6>

        <ul v-if="categories" class="flex flex-wrap">
            <li
                v-for="(cat, index) in categories"
                :key="index"
                class="relative px-6 py-3 mb-4 mr-5 leading-none h6 rounded-3xl min-w-medium text-center"
                :class="{
                    'is-active text-white bg-blue-navy': active == cat,
                    'text-blue-navy bg-white': active != cat
                }"
            >
                <input
                    v-model="active"
                    type="radio"
                    :value="cat"
                    class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                />
                <label> {{ cat }}</label>
            </li>
        </ul>
        <slot />
    </nav>
</template>
<script>
export default {
    props: {
        categories: {
            type: Array,
            default: null
        },
        activeFilter: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            active: this.activeFilter
        };
    },

    watch: {
        active() {
            this.$emit('update:activeFilter', this.active);
        }
    }
};
</script>
